import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT,
    CONTINUE_TO_PAYMENT_CTA_LAYER_EXPERIMENT,
    EXPRESS_CHECKOUT_EXPERIMENT,
    IMPLICIT_TOS_ACCEPTANCE_EXPERIMENT,
    MobileCartSummaryButtonVariant,
    MOBILE_CART_SUMMARY_BUTTON_EXPERIMENT,
    SortAvailableTicketsCriteria,
    SORT_AVAILABLE_TICKETS_FIRST_EXPERIMENT,
    TicketsPageButtonEnabledCriteria,
    TrustMessageText,
    TRUST_MESSAGE_EXPERIMENT,
    UPDATE_DATE_FORMAT_EXPERIMENT,
} from '../constants/statsig';

export const checkCardImprovementsFeatureGate = () =>
    checkGate('checkout_card_improvements');

export const getTrustMessageExperimentValue = () =>
    getExperiment(
        TRUST_MESSAGE_EXPERIMENT.name,
        TRUST_MESSAGE_EXPERIMENT.param,
        TRUST_MESSAGE_EXPERIMENT.defaultValue,
    );

export const isExpressCheckoutVariant = (): boolean => {
    const value = getExperiment(
        EXPRESS_CHECKOUT_EXPERIMENT.name,
        EXPRESS_CHECKOUT_EXPERIMENT.param,
        EXPRESS_CHECKOUT_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const isNoMessageVariant = () =>
    getTrustMessageExperimentValue() === TrustMessageText.NO_MESSAGE;

export const isTransactionSafeVariant = () =>
    getTrustMessageExperimentValue() ===
    TrustMessageText.VARIANT_TRANSACTION_SAFE;

export const getSimplifyCartSummaryButtonExperiment = () =>
    getLayer<MobileCartSummaryButtonVariant, MobileCartSummaryButtonVariant>(
        MOBILE_CART_SUMMARY_BUTTON_EXPERIMENT.layer,
        MOBILE_CART_SUMMARY_BUTTON_EXPERIMENT.param,
        MOBILE_CART_SUMMARY_BUTTON_EXPERIMENT.defaultValue,
    );

export const isContinueToPaymentCTAExperimentEnabled = (): boolean => {
    const value = getLayer(
        CONTINUE_TO_PAYMENT_CTA_LAYER_EXPERIMENT.layer,
        CONTINUE_TO_PAYMENT_CTA_LAYER_EXPERIMENT.param,
        CONTINUE_TO_PAYMENT_CTA_LAYER_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const getSortAvailableTicketsFirstExperimentVariant = () =>
    getLayer<SortAvailableTicketsCriteria, SortAvailableTicketsCriteria>(
        SORT_AVAILABLE_TICKETS_FIRST_EXPERIMENT.layer,
        SORT_AVAILABLE_TICKETS_FIRST_EXPERIMENT.param,
        SORT_AVAILABLE_TICKETS_FIRST_EXPERIMENT.defaultValue,
    );

export const getAlwaysEnableTicketsPageButtonExperimentVariant = () =>
    getLayer<
        TicketsPageButtonEnabledCriteria,
        TicketsPageButtonEnabledCriteria
    >(
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.layer,
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.param,
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.defaultValue,
    );

export const isImplicitToSAcceptanceExperimentEnabled = () => {
    const value = getLayer(
        IMPLICIT_TOS_ACCEPTANCE_EXPERIMENT.layer,
        IMPLICIT_TOS_ACCEPTANCE_EXPERIMENT.param,
        IMPLICIT_TOS_ACCEPTANCE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const isUpdateFormatDateExperimentEnabled = () => {
    const value = getLayer(
        UPDATE_DATE_FORMAT_EXPERIMENT.layer,
        UPDATE_DATE_FORMAT_EXPERIMENT.param,
        UPDATE_DATE_FORMAT_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};
